import React, { ReactNode } from 'react';

import * as S from './styles';
import AlertBarSimple from '../AlertBarSimple';
import WarningIcon from '@mui/icons-material/Warning';

interface Props {
  color: 'danger' | 'warning' | 'tertiary' | 'white' | 'aqua';
  text: ReactNode;
  button?: ReactNode;
  icon?: ReactNode;
  iconColor?: 'danger' | 'warning' | 'tertiary' | 'white';
  noWarning?: boolean;
  noWarningIcon?: boolean;
  onClick?: () => void;
  pointer?: boolean;
  flexDirection?: 'column' | 'row';
  buttonAlign?: 'end';
}

export default function AlertBar({
  color: colorSelected = 'danger',
  text,
  button,
  noWarning,
  icon,
  iconColor,
  pointer,
  onClick,
  noWarningIcon,
  flexDirection = 'row',
  buttonAlign,
}: Props) {
  const alignEnd = buttonAlign === 'end';

  return (
    <AlertBarSimple
      color={colorSelected}
      style={{
        cursor: pointer ? 'pointer' : 'default',
        flexDirection: flexDirection,
        ...(alignEnd ? { flexWrap: 'nowrap', columnGap: '1rem' } : {}),
      }}
      onClick={onClick && onClick}
    >
      <S.Warning $alignEnd={alignEnd}>
        {<S.Icon iconColor={iconColor}>{icon}</S.Icon>}
        {!noWarningIcon && <WarningIcon fontSize="large" />}
        {typeof text === 'string' ? (
          <S.P $alignEnd={alignEnd}>
            {!noWarning && <strong>Atenção!</strong>} {text}
          </S.P>
        ) : (
          <>
            {!noWarning && <strong>Atenção!</strong>} {text}
          </>
        )}
      </S.Warning>
      {alignEnd ? <S.ButtonSlot>{button}</S.ButtonSlot> : button}
    </AlertBarSimple>
  );
}
